import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ConfiguratorView, { type ResolvedConfig } from "../ConfiguratorView";
import { resolveShowcaseModel } from "../../features/vault/vaultApi";

/** Public interactive view of one showcase model. */
export default function ShowcaseModelPage() {
  const { slug, modelId } = useParams<{ slug: string; modelId: string }>();
  const [data, setData] = useState<ResolvedConfig | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    resolveShowcaseModel(slug!, modelId!)
      .then((d) => alive && setData(d as ResolvedConfig))
      .catch((e) => alive && setError(e instanceof Error ? e.message : "Unavailable"));
    return () => {
      alive = false;
    };
  }, [slug, modelId]);

  if (error)
    return (
      <div className="flex h-screen items-center justify-center bg-ink-950 text-ink-300">
        <p className="text-[14px]">{error}</p>
      </div>
    );
  if (!data)
    return (
      <div className="flex h-screen items-center justify-center bg-ink-950">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-gold-400 border-t-transparent" />
      </div>
    );

  return (
    <div className="relative h-screen w-screen">
      <ConfiguratorView data={data} />
      <Link
        to={`/showcase/${slug}`}
        className="absolute left-3 top-3 z-40 flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 text-[12px] font-medium text-ink-800 shadow-sm backdrop-blur transition-colors hover:text-ink-900"
      >
        <ArrowLeft size={14} /> Collection
      </Link>
    </div>
  );
}
